"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tree = exports.Tournament = exports.Sport = exports.SbType = exports.MatchStatus = exports.Category = void 0;
var category_js_1 = require("./tree/category.js");
Object.defineProperty(exports, "Category", { enumerable: true, get: function () { return category_js_1.Category; } });
var match_status_js_1 = require("./tree/match-status.js");
Object.defineProperty(exports, "MatchStatus", { enumerable: true, get: function () { return match_status_js_1.MatchStatus; } });
var sb_type_js_1 = require("./tree/sb-type.js");
Object.defineProperty(exports, "SbType", { enumerable: true, get: function () { return sb_type_js_1.SbType; } });
var sport_js_1 = require("./tree/sport.js");
Object.defineProperty(exports, "Sport", { enumerable: true, get: function () { return sport_js_1.Sport; } });
var tournament_js_1 = require("./tree/tournament.js");
Object.defineProperty(exports, "Tournament", { enumerable: true, get: function () { return tournament_js_1.Tournament; } });
var tree_js_1 = require("./tree/tree.js");
Object.defineProperty(exports, "Tree", { enumerable: true, get: function () { return tree_js_1.Tree; } });
